// extracted by mini-css-extract-plugin
module.exports = {"presaleSpecs":"Specs_presaleSpecs__Usq9x"};